import React from 'react';

import Icon from '../../Icons';

import * as S from './styles';

export default function DropdownContent({ contrastTheme, notifications }) {
    return (
        <S.DropdownContentContainer>
            <S.Header>
                Notificações <Icon name="settings" size={20} color={contrastTheme ? '#FFF333' : '#5B5B5F'} />
            </S.Header>

            <S.UnorderedList>
                {notifications?.map((notification, index) => (
                    <S.List key={index}>
                        <S.Anchor href={notification.url}>
                            <S.ContainerTitle>
                                <S.Dot />

                                {notification.descricao}
                            </S.ContainerTitle>

                            {notification.formattedDate}
                        </S.Anchor>
                    </S.List>
                ))}
            </S.UnorderedList>
        </S.DropdownContentContainer>
    );
}
